import React from 'react';
import { Layout } from 'react-admin';
import TipspaAppBar from './TipspaAppBar';

const TipspaLayout = (props) => <Layout {...props} appBar={TipspaAppBar} />;

export default TipspaLayout;